import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';

export type SetUserPasswordVariables = {
    id: string;
    password: string;
};

/**
 * Resets a back-office user's password. No list field changes, so there's
 * nothing to invalidate.
 */
export const useSetUserPasswordMutation = () => {
    const { apiClient } = useApi();

    return useMutation<ApiResponse<void>, Error, SetUserPasswordVariables>({
        mutationFn: ({ id, password }) =>
            apiClient.users.setUserPassword(id, { password }),
    });
};
